import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import StripeCard from "components/Objects/StripeCard";
import APPCONFIG from "../../constants/Config";
import TextField from "@material-ui/core/TextField";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";

class StripeCharge extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Stripe_Charges._name);
		this.state.paid = false;
		this.state.key = '';
		this.state.changedEmail = Math.random();
		this.state.emailChanged = false;
		this.state.show_stripe_locally = false;
		this.state.quantity = 1;
		const customerId = Number(props.customer);
		if (Number.isInteger(customerId) && customerId > 0) {
			this.state.customer = customerId;
		}
	}

	handlePaidStatus = async () => {
		this.setState({paid: true});
		setTimeout(async () => {
			this.setState({show_stripe_locally: false})
			await this.props.afterSave();
		}, 1000)
	}

	handleEmailUpdate = (e) => {
		this.state.customers.email = e.target.value;
		this.setState({customers: {...this.state.customers, ...{email: e.target.value}}, emailChanged: true})
	};

	updateCustomerEmail = () => {
		//update the customer's email
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.UPDATE);
		model.object.pkey = this.state.customer;
		model.object.email = this.state.customers.email;
		model.submit(null, 'POST_EMAIL').then();

		//set changedEmail here so the stripe checkout updates
		this.setState({changedEmail: Math.random(), emailChanged: false})
	}

	handleSendEmail = async () => {
		let billing = new API.BuildClass(Types.Stripe_Charges._name, API.RequestType.CREATE);
		billing.object.customer = this.state.customer;
		billing.object.customer_email = this.state.customers.email;
		billing.object.stripe_product = this.state.stripe_product;
		billing.object.quantity = this.state.quantity;
		if (this.props.avCenter) {
			billing.object.av_center = true;
		}
		await billing.submit(null, 'PUT_CUSTOMER_PAYMENT_LINK', true);
		await this.props.afterSave();
	}

	render() {
		const {properties} = this.model;
		let object = this.state;

		const stripePromise = loadStripe((APPCONFIG.settings.isDev() || APPCONFIG.settings.isBeta()) ? "pk_test_51Ln4LsH1LbE5v4o227c1kTjOh3363urJxmr1E3ctMyvmQyso0P1NbY6VHJNqL5GD300OJaWOgyjS0eB9doAVP4oH00VAwTqG8g" : "pk_live_51Ln4LsH1LbE5v4o2YnJGF8VCfbZX5O3tFG3az5AoNZ7yQz9kQ3ezXl51YGFwIMzQNGiia8VzeaMhbCvKOEPLpyyQ00bHqAohHf");

		return (
			<fieldset>
				<div className={'row'}>
					<div className={'col-6'}>
						<Framework.Elements.Select
							shouldLoad={true}
							label={"Product"}
							property={properties.stripe_product}
							value={object.stripe_product}
							error={object.stripe_product_error}
							update={this.handleSelectPropertyUpdate}
							text={"name"}
							nullable={true}
						/>
					</div>
					<div className={'col-6'}>
						<Framework.Elements.Select
							shouldLoad={true}
							label={"Customer"}
							property={properties.customer}
							value={object.customer}
							object={object.customers}
							error={object.customer_error}
							update={this.handleSelectPropertyUpdate}
							text={"name&email"}
							nullable={true}
						/>
					</div>
				</div>
				<br/>
				<div className={'row'}>
					<div className={'col-6'}>
						{this.state.stripe_products &&
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Description"}
									value={this.state.stripe_products.description ?? ""}
									variant="outlined"
									disabled={true}
								/>
							</div>
						}
						{this.state.stripe_products &&
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Quantity"}
									value={this.state.quantity}
									onChange={(e) => {
										const val = e.target.value;
										const isValid = /^\d+$/.test(val) && +val >= 1 && +val <= 100;
										this.setState({
											quantity: isValid || val.length === 0 ? val : 1
										});
									}}
									variant="outlined"
								/>
							</div>
						}
					</div>
					{this.state.customers &&
						<div className={'col-6'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Email"}
									value={this.state.customers.email}
									onChange={(e) => this.handleEmailUpdate(e)}
									variant="outlined"
								/>
								{this.state.emailChanged &&
									<Button style={{marginTop: "5px"}} data-id="add-user" onClick={this.updateCustomerEmail} size="sm"
									        color="primary">
										<i className="fa fa-user"/>&nbsp;&nbsp;Update Customer Email
									</Button>
								}
							</div>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Phone"}
									value={this.state.customers.phone}
									key={this.state.customers.phone}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
					}
				</div>
				{object.stripe_products?.name && object.stripe_products?.name.includes('BitDefender') &&
					<b style={{alignSelf: 'center'}}>BitDefender Download Link will be available in the Sales table upon completion.</b>}
				{this.state.stripe_product && this.state.customer &&
					<div className={'row d-flex px-0'} style={{marginTop: '15px'}} key={Math.random()}>
						{!this.state.show_stripe_locally &&
							<div className={'col-6 p-0'} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
								<Button onClick={() => {
									this.setState({show_stripe_locally: !this.state.show_stripe_locally})
								}} size="lg" color="primary" style={{borderRadius: '25px'}}>
									Enter Credit Card
								</Button>
							</div>
						}
						<div className={'col-6 p-0'} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
							<Button key={Math.random()}
							        onClick={async () => {
								        await this.handleSendEmail()
							        }} size="lg" color="primary" style={{borderRadius: '25px'}}>
								{this.state.show_stripe_locally ? 'Email Client Payment Link' : 'Send Payment to Client Email'}
							</Button>
						</div>
					</div>
				}
				{this.state.show_stripe_locally &&
					<div className={'row'} key={this.state.stripe_product + " " + this.state.customer + " " + this.state.changedEmail}>
						<Elements stripe={stripePromise}>
							<StripeCard
								handlePaidStatus={async () => {
									await this.handlePaidStatus()
								}}
								customer={this.state.customer}
								customer_email={this.state.customers.email}
								product={this.state.stripe_product}
								baseUrl={'/accounts#billing'}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								history={this.props.history}
								quantity={this.state.quantity}
								avCenter={!!this.props.avCenter}
								// closeModal={() => {
								// 	if (typeof (this.props.afterSave) === 'function') {
								// 		this.props.afterSave()
								// 	}
								// }}
							/>
						</Elements>
					</div>
				}
				{this.state.paid &&
					<div>
						The license key just purchased: {this.state.key}
					</div>
				}
			</fieldset>
		)
	}
}

export default Framework.Components.withRootState(StripeCharge);
